import React, { FC } from "react";
import { ControlsPanel } from "./ControlsPanel";
import { ActionCard } from "./ActionCard";
import { ISlide } from "./types";
import { SafeHTML } from "src/components/SafeHTML";

export const Slide: FC<ISlide> = ({ title, image, text, buttonLabel }) => {
  return (
    <div className="relative w-full">
      <div className="w-full h-200">
        <img
          className="w-full h-full object-cover rounded-15"
          src={image}
          alt={title}
        />
      </div>

      <SafeHTML
        html={title}
        tag="h1"
        className="absolute top-20 sm:top-17.5 left-4 sm:left-9 text-white-base"
      />

      <ControlsPanel />
      <ActionCard text={text} buttonLabel={buttonLabel} />
    </div>
  );
};
